import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationRiskTarget = createCrudVuexModule({
  namespaced: true,
  path: "/risk-target",
  options: { localizedFields: ["name", "description", "criticality"] },

  state: {},

  mutations: {},

  actions: {
    async fetchTarget({ commit, state }, payload) {
      try {
        commit("isLoading", true);
        const response = await rest.get(`/risk-target`);
        commit("selectedEntity", response.data);
        return response.data;
      } finally {
        commit("isLoading", false);
      }
    },
    async save({ commit, state }, payload) {
      try {
        commit("isUpdating", true);
        const response = await rest.put(`/risk-target`, { item: payload });
        commit("selectedEntity", response.data);
        return response.data;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
